import { render, staticRenderFns } from "./drag.vue?vue&type=template&id=42e1795e"
import script from "./drag.vue?vue&type=script&lang=js"
export * from "./drag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports